import { render, staticRenderFns } from "./ManterPeticaoExibir.vue?vue&type=template&id=1c293df8&scoped=true&"
import script from "./ManterPeticaoExibir.vue?vue&type=script&lang=js&"
export * from "./ManterPeticaoExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c293df8",
  null
  
)

export default component.exports